import { Stack } from "@chakra-ui/react";
import PageHeader from "components/layout/PageHeader";
import { Header } from "../components/header";
import { DrawsTable } from "../components/tables/draws-table";

export function Draws() {
  return (
    <>
      <PageHeader title="Draws" />

      <Stack gap={4}>
        <Header />
        <DrawsTable />
      </Stack>
    </>
  );
}
